import * as Types from '../../__generated_types__/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UserProfileBonusForfeitMutationVariables = Types.Exact<{
  xTenantId: Types.Scalars['ID']['input'];
  userProfileId: Types.Scalars['ID']['input'];
  userProfileBonusId: Types.Scalars['ID']['input'];
}>;


export type UserProfileBonusForfeitMutation = { __typename?: 'Mutation', userProfileBonusForfeit?: any | null };


export const UserProfileBonusForfeitDocument = gql`
    mutation UserProfileBonusForfeit($xTenantId: ID!, $userProfileId: ID!, $userProfileBonusId: ID!) {
  userProfileBonusForfeit(
    xTenantID: $xTenantId
    userProfileId: $userProfileId
    userProfileBonusId: $userProfileBonusId
  )
}
    `;
export type UserProfileBonusForfeitMutationFn = Apollo.MutationFunction<UserProfileBonusForfeitMutation, UserProfileBonusForfeitMutationVariables>;

/**
 * __useUserProfileBonusForfeitMutation__
 *
 * To run a mutation, you first call `useUserProfileBonusForfeitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserProfileBonusForfeitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userProfileBonusForfeitMutation, { data, loading, error }] = useUserProfileBonusForfeitMutation({
 *   variables: {
 *      xTenantId: // value for 'xTenantId'
 *      userProfileId: // value for 'userProfileId'
 *      userProfileBonusId: // value for 'userProfileBonusId'
 *   },
 * });
 */
export function useUserProfileBonusForfeitMutation(baseOptions?: Apollo.MutationHookOptions<UserProfileBonusForfeitMutation, UserProfileBonusForfeitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserProfileBonusForfeitMutation, UserProfileBonusForfeitMutationVariables>(UserProfileBonusForfeitDocument, options);
      }
export type UserProfileBonusForfeitMutationHookResult = ReturnType<typeof useUserProfileBonusForfeitMutation>;
export type UserProfileBonusForfeitMutationResult = Apollo.MutationResult<UserProfileBonusForfeitMutation>;
export type UserProfileBonusForfeitMutationOptions = Apollo.BaseMutationOptions<UserProfileBonusForfeitMutation, UserProfileBonusForfeitMutationVariables>;